import React, { useEffect, useRef } from 'react'

import { EffectBackgroundProps } from '../types'

export const NoiseEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const noiseCanvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = noiseCanvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    canvas.width = 400
    canvas.height = 400

    let animationId: number
    const grainIntensity = 100

    const drawNoise = () => {
      const imageData = ctx.createImageData(canvas.width, canvas.height)
      const data = imageData.data

      for (let i = 0; i < data.length; i += 4) {
        const value = Math.random() * 255 * (grainIntensity / 100)
        data[i] = value
        data[i + 1] = value
        data[i + 2] = value
        data[i + 3] = 255
      }

      ctx.putImageData(imageData, 0, 0)

      const delay = Math.max(16, 100 / (effectSpeed / 100))
      setTimeout(() => {
        animationId = requestAnimationFrame(drawNoise)
      }, delay)
    }

    drawNoise()

    return () => {
      if (animationId) cancelAnimationFrame(animationId)
    }
  }, [effectSpeed])

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      <canvas
        ref={noiseCanvasRef}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          opacity: opacityValue,
          imageRendering: 'pixelated',
        }}
      />
    </div>
  )
})
NoiseEffect.displayName = 'NoiseEffect'
